import type { ReactNode } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { useInAppAppearance } from "@/react/components/Paywalls/StripeElements/useInAppAppearance";
import { useStripeElement } from "@/react/hooks/paywalls/useStripeElement";
import type { BillingInfoContextProps } from "./BillingInfoContextProps";
import { BillingInfoFormWrapper } from "./BillingInfoFormWrapper";

export interface BillingInfoFormProviderProps extends BillingInfoContextProps {
  children: ReactNode;
}

export const BillingInfoFormProvider = ({
  children,
  ...props
}: BillingInfoFormProviderProps) => {
  const { stripePromise: stripe } = useStripeElement();
  const appearance = useInAppAppearance();

  return (
    <Elements stripe={stripe} options={{ appearance }}>
      <BillingInfoFormWrapper {...props}>{children}</BillingInfoFormWrapper>
    </Elements>
  );
};
